module.exports = __webpack_public_path__ + "static/03-4bc536d7fcf1dc21a6da9c911a350a61.jpg";